import { render, staticRenderFns } from "./feedback.vue?vue&type=template&id=397b088c&scoped=true"
import script from "./feedback.vue?vue&type=script&lang=js"
export * from "./feedback.vue?vue&type=script&lang=js"
import style0 from "./feedback.vue?vue&type=style&index=0&id=397b088c&prod&lang=less&scoped=true"
import style1 from "./feedback.vue?vue&type=style&index=1&id=397b088c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397b088c",
  null
  
)

export default component.exports